import { ThemeButton } from "../../../../molecules/buttons/ThemeButton";
import { ThemeControlReact } from "../ThemeControlReact";

export function ThemeButtonReact() {
  return (
    <ThemeButton>
      <ThemeControlReact />
    </ThemeButton>
  );
}
